import type { NavigationCounts } from '@risksmart-app/trpc/src/types';
import type { GetInternalAuditReportCountQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetInternalAuditReportCountDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { COUNT_STALE_TIME_MS, createQueryHook } from 'src/utils';

import type { NavigationCountArgs } from '../navigation/navigationCounts';
import {
  navigationCountsQueryOptions,
  toAggregate,
} from '../navigation/navigationCounts';

export const useGetInternalAuditReportCount = createQueryHook<
  NavigationCountArgs,
  NavigationCounts,
  GetInternalAuditReportCountQuery
>({
  trpcQueryOptions: navigationCountsQueryOptions,
  mapTrpcDataToGraphQL: (data) => ({
    internal_audit_report_aggregate: {
      aggregate: toAggregate(data.internalAuditReport),
    },
  }),
  // Aggregate over a register; mutations invalidate it. See COI-882.
  trpcStaleTime: COUNT_STALE_TIME_MS,
  graphqlDocument: GetInternalAuditReportCountDocument,
});
